// esbuild doesn't bundle moment's dynamically required locales, so load the ones WorkToday uses explicitly
import moment from 'moment';
import 'moment/locale/nl';
import 'moment/locale/fr';

// Importing a locale file makes it the global default; keep moment's default ('en') as before
moment.locale('en');
